import type { FiltersStore } from '@tools/search/getFiltersStore';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type FiltersConfigState = {
  filtersStore: FiltersStore | null;
  loading: boolean;
};

export const initialState: FiltersConfigState = {
  filtersStore: null,
  loading: false,
};

const filtersConfigSlice = createSlice({
  name: 'filtersConfig',
  initialState,
  reducers: {
    updateFiltersConfigRequest(state) {
      state.loading = true;
    },

    updateFiltersConfigSuccess(
      state,
      action: PayloadAction<FiltersStore | null>
    ) {
      state.filtersStore = action.payload;
      state.loading = false;
    },
  },
});

export const filtersConfig = filtersConfigSlice.reducer;

export const { updateFiltersConfigRequest, updateFiltersConfigSuccess } =
  filtersConfigSlice.actions;
